import { ArrowDownTrayIcon, PlusIcon } from '@heroicons/react/24/outline';
import { Tooltip } from 'react-tooltip';
import { AssignProductToDosageDiaryModal } from './AssignProductToDosageDiaryModal';
import { DosageDiaryProfileContentProps } from '../interface/interface';
import { useToFetchAllocatedDosageDiaryProducts } from '../hooks/useToFetchAllocatedProductsByProfile';
import { useEffect, useState } from 'react';
import { DocumentCard } from './DocumentCard';
import { useToUnassignProductFromDDProfile } from '../hooks/useToUnassignProductFromDDProfile';
import { useToDownloadDosageDiaryPDF } from '../hooks/useToDownloadDosageDiaryPDF';

export function DosageDiaryProfileContent({
  profile,
  setModalvisibility,
  modalVisibility,
  token,
}: DosageDiaryProfileContentProps) {
  const [fetchCounter, setFetchCounter] = useState(false);

  const [profileHandler, assignedProducts] =
    useToFetchAllocatedDosageDiaryProducts(token, fetchCounter);

  const [handleRemoval] = useToUnassignProductFromDDProfile(token, () =>
    setFetchCounter((pre) => !pre),
  );

  const { handleDosageDiaryDownloadByProfile } =
    useToDownloadDosageDiaryPDF(token);
  const [invokeProductFetch, setProductFetchInvoke] = useState<number>(0);

  useEffect(() => {
    if (!profile.id) return;

    profileHandler(profile.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.id, fetchCounter]);

  return (
    <section aria-labelledby="profile">
      <div className="overflow-hidden rounded-lg bg-white shadow h-full">
        <div className="p-6">
          <div className="border-b border-gray-200 pb-5 sm:flex sm:items-center sm:justify-between">
            <h3 className="text-base font-semibold text-gray-900">
              {profile.name}
            </h3>
            <div>
              <span className="isolate inline-flex">
                <button
                  type="button"
                  data-tooltip-place="top-start"
                  data-tooltip-id="assign-product"
                  className="relative inline-flex items-center bg-white 
                      px-2 py-2 hover:bg-gray-50 focus:z-10"
                  onClick={() => setModalvisibility(true)}
                >
                  <PlusIcon aria-hidden="true" className="size-5" />
                </button>
                <button
                  type="button"
                  data-tooltip-place="top-start"
                  data-tooltip-id="download-dosage-diary-document"
                  className="relative -ml-px inline-flex items-center 
                      bg-white px-2 py-2 hover:bg-gray-50 focus:z-10"
                  onClick={async () => {
                    await handleDosageDiaryDownloadByProfile(
                      profile.id,
                      profile.name,
                    );
                  }}
                >
                  <ArrowDownTrayIcon aria-hidden="true" className="size-5" />
                </button>
                <Tooltip id="download-dosage-diary-document">
                  Download Dosage Diary Document
                </Tooltip>
                <Tooltip id="assign-product">Assign Product</Tooltip>
              </span>
            </div>
          </div>
          {assignedProducts.length ? (
            <div
              className="py-4 overflow-y-auto max-h-96 
            [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300"
            >
              <div className="py-3">
                <p className="font-semibold">Assigned Products</p>
              </div>
              <DocumentCard
                item={assignedProducts.map((e) => ({
                  name: e.name,
                  size: '',
                  onDelete: async () => {
                    await handleRemoval(e.id);
                    setProductFetchInvoke((p) => p + 1);
                  },
                }))}
              />
            </div>
          ) : (
            <div className="p-6 flex items-center justify-center h-full">
              <p className="font-semibold text-center">No products assigned</p>
            </div>
          )}
        </div>
        <div className="p-6">
          <AssignProductToDosageDiaryModal
            isVisible={modalVisibility}
            setVisibility={(val) => setModalvisibility(val)}
            profileName={profile.name}
            profileId={profile.id}
            invoke={invokeProductFetch}
            setCounter={() => setFetchCounter((prev) => !prev)}
          />
        </div>
      </div>
    </section>
  );
}
